import React, { useEffect, useState } from "react"
import {
  Form,
  Select,
  // message,
} from "antd"
// import "./index.scss"
import { codetype } from "@/utils"

import axios from 'axios';

const chushihua = (vv) => {
  let v = []
  if (vv.toString().substring(0, 2) > 0) { v.push(vv.toString().substring(0, 2) * 1) }
  if (vv.toString().substring(2, 4) > 0) { v.push(vv.toString().substring(0, 4) * 100000000) }
  if (vv.toString().substring(4, 6) > 0) { v.push(vv.toString().substring(0, 6) * 1000000) }
  if (vv.toString().substring(6, 9) > 0) { v.push(vv.toString().substring(0, 9) * 1000) }
  if (vv.toString().substring(9, 12) > 0) { v.push(vv) }

  return v

}
const intdata = {
  key: "0",
  value: "",
  label: "请选择",
}
const App = ({ limitcode = 0, level = 5, onChange = () => { }, value = 0, cunshow = true }) => {
  const [form] = Form.useForm()
  // console.log(chushihua(value));
  const [sheng, setSheng] = useState([intdata])
  const [shi, setShi] = useState([intdata])
  const [xian, setXian] = useState([intdata])
  const [xiang, setXiang] = useState([intdata])
  const [cun, setCun] = useState([intdata])
  const [dic, setDic] = useState({})
  const [limit,] = useState(limitcode > 0 ? codetype(limitcode) : 0)
  // console.log(list);

  useEffect(() => {
    getdatalist(limitcode)
    if (value) {
      getdataint(value)
    }
    // eslint-disable-next-line
  }, [])

  const getdataint = async (value) => {

    // var res = await getdata({
    //     method: 'get', params: {
    //         codes: chushihua(value).join(","),
    //         notree: 1
    //     }
    // })
    // var res = await http.get(`/api/5fe988d359d4a?codes=${chushihua(value).join(",")}&notree=1`)

    var res = await axios({
      url: `http://dataapi.kailiyun.com.cn:8090/api/5fe988d359d4a?codes=${chushihua(value).join(",")}&notree=1`,
      method: 'get',
      timeout: 5000,
      headers: {
        'access-token': 'VyKvUYjGNMVQDzmzWitbanxSqwjiufzi',
      },
    })


    let obj = res.data.data
    // console.log(obj);
    let sheng = ""
    let shi = ""
    let xian = ""
    let xiang = ""
    let cun = ""
    getdatalist(0)
    for (let k in obj) {
      let v = obj[k]
      // console.log(v);
      v.code = v.code || v.id
      if (codetype(v.code) === "sheng") {
        getdatalist(v.code)
        sheng = v.code
      }
      if (codetype(v.code) === "shi") {
        getdatalist(v.code)
        shi = v.code
      }
      if (codetype(v.code) === "xian") {
        getdatalist(v.code)
        xian = v.code
      }
      if (codetype(v.code) === "xiang") {
        getdatalist(v.code)
        xiang = v.code
      }
      if (codetype(v.id) === "cun") {

        cun = v.code
      }
    }
    setTimeout(() => {
      form.setFieldsValue({ sheng, shi, xian, xiang, cun })
    }, 500)
  }
  const getdatalist = async (code) => {
    let ctype = 0
    if (code !== 0) {
      ctype = codetype(code)
    }
    // var res = await http.get(`/api/5fe19ff703162?code=${code}`)
    var res = await axios({
      url: `http://dataapi.kailiyun.com.cn:8090/api/5fe19ff703162?code=${code}`,
      method: 'get',
      timeout: 5000,
      headers: {
        'access-token': 'VyKvUYjGNMVQDzmzWitbanxSqwjiufzi',
      },
    })
    let arr = []
    let tem = dic
    arr.push(intdata)
    res.data.data.forEach((v) => {
      delete v.id
      delete v.pcode
      tem[v.code] = v
      arr.push({
        key: v.code,
        value: v.code,
        label: v.title,
      })
    })
    if (ctype === 0) {
      setSheng(arr)
    }
    if (ctype === "sheng") {
      setShi(arr)
    }
    if (ctype === "shi") {
      setXian(arr)
    }
    if (ctype === "xian") {
      setXiang(arr)
    }
    if (ctype === "xiang") {
      setCun(arr)
    }
    setDic(tem)
  }

  const onFormLayoutChange = (a, b) => {
    let tem = {}
    let arr = []
    for (let k in b) {
      if (b[k]) {
        arr.push(b[k])

        tem[k] = dic[b[k]] || ""
      }
    }
    arr = Math.max.apply(null, arr)
    onChange(arr, tem)
  }

  return (
    <>
      <Form

        layout="inline"
        form={form}
        initialValues={{

        }}
        onValuesChange={onFormLayoutChange}
        style={{
          width: '100%',
        }}
        className='qhbox'
      >
        {[1, 2, 3, 4, 5].includes(level) && <Form.Item name="sheng" style={{ display: [0].includes(limit) ? "" : "none" }}>
          <Select
            placeholder={"选择省"}
            onChange={(e) => {
              setXian([intdata])
              setXiang([intdata])
              setCun([intdata])
              form.setFieldsValue({ shi: "", xian: "", xiang: "", cun: "" })
              getdatalist(e)
            }}
            options={sheng}
          ></Select>
        </Form.Item>}
        {[2, 3, 4, 5].includes(level) && <Form.Item name="shi" style={{ display: [0, "sheng"].includes(limit) ? "" : "none" }}>
          <Select
            placeholder={"选择市"}
            onChange={(e) => {
              setXiang([intdata])
              setCun([intdata])
              form.setFieldsValue({ xian: "", xiang: "", cun: "" })
              getdatalist(e)
            }}
            options={shi}
          ></Select>
        </Form.Item>}
        {[3, 4, 5].includes(level) && <Form.Item name="xian" style={{ display: [0, "sheng", "shi"].includes(limit) ? "" : "none" }}>
          <Select
            placeholder={"选择县"}
            onChange={(e) => {

              setCun([intdata])
              form.setFieldsValue({ xiang: "", cun: "" })
              getdatalist(e)
            }}
            options={xian}
          ></Select>
        </Form.Item>}
        {[4, 5].includes(level) && <Form.Item name="xiang" style={{ display: [0, "sheng", "shi", "xian"].includes(limit) ? "" : "none" }}>
          <Select
            placeholder={"选择乡"}
            onChange={(e) => {
              form.setFieldsValue({ cun: "" })
              getdatalist(e)
            }}
            options={xiang}
          ></Select>
        </Form.Item>}
        {([5].includes(level) && cunshow) && <Form.Item name="cun" style={{ display: [0, "sheng", "shi", "xian", "xiang"].includes(limit) ? "" : "none" }}>
          <Select
            placeholder={"选择村"}
            onChange={(e) => { getdatalist(e) }}
            options={cun}
          ></Select>
        </Form.Item>}
      </Form>
    </>
  )
}

export default App 
